import { useEffect, useState } from 'react';
import { fetchAddressesByAwbs } from '../../helpers/delayMisExport';

/**
 * Loads pickup (origin) + drop (destination) addresses for a set of AWBs from order/search,
 * so the Shipment-Alert grids can show a Pickup → Drop route inline. The CT delay feed has
 * no addresses, so we enrich by AWB here. Refetches only when the AWB set actually changes
 * (keyed on the sorted AWB list), so switching tabs / re-renders don't refetch.
 *
 * Returns { addrMap, loading } where addrMap[awb] = {fromPincode, fromCity, fromState,
 * toPincode, toCity, toState}.
 */
export default function useAddressesByAwb(awbNumbers = []) {
  const [addrMap, setAddrMap] = useState({});
  const [loading, setLoading] = useState(false);
  const key = [...new Set((awbNumbers || []).filter(Boolean))].sort().join(',');

  useEffect(() => {
    let active = true;
    if (!key) { setAddrMap({}); return undefined; }
    setLoading(true);
    fetchAddressesByAwbs(key.split(','))
      .then((map) => { if (active) setAddrMap(map || {}); })
      .catch(() => { if (active) setAddrMap({}); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [key]);

  return { addrMap, loading };
}
